import { Skeleton } from '@/shared/components';
import { cn } from '@/shared/utils';

type Props = {
  description: string;
  isLoading: boolean;
  errorMessage: string | null;
  className?: string;
};

const ExchangeRateLine = ({
  description,
  isLoading,
  errorMessage,
  className,
}: Props) => {
  return (
    <div className={cn('flex h-[2rem] items-center', className)}>
      {isLoading ? (
        <Skeleton variant="small" className="w-[22rem] bg-stroke" />
      ) : (
        <span className="medium5 text-secondary truncate">
          {errorMessage ?? description}
        </span>
      )}
    </div>
  );
};

export { ExchangeRateLine };
